import { useConfigStore } from '../stores/ConfigStore';

/** Returns the app-configured reels shelf playlist id, used to load the reels feed. */
export const getReelsPlaylistId = (): string | undefined => {
  const { config } = useConfigStore.getState();
  return config.content?.find((c) => c.custom?.mediaType === 'reels')?.contentId;
};
